import { createMemo } from "solid-js";
import { isNil } from "lodash-es";
import InlineBanner from "../../../components/banner/InlineBanner";
import { useTranslation } from "../../../state/i18n";
import { useCustomerState } from "../../../state/customer";
import PermissionService from "../../../services/PermissionService";
import { CUSTOMER_DELETION_DELAY_DAYS, LEGACY_PLATFORM_BASE_URL } from "../../../constants";
import { daysUntil } from "../../../utils/dateUtil";

const ScheduledForDeletionBanner = () => {
  const { t } = useTranslation();
  const customer = useCustomerState();

  const canManageBilling = createMemo(() => PermissionService.canManageBilling(customer.customerId));

  const daysProgress = createMemo(() => {
    if (isNil(customer.meta.deleteOn)) {
      return { elapsed: 0, total: CUSTOMER_DELETION_DELAY_DAYS };
    }

    const remaining = Math.max(daysUntil(customer.meta.deleteOn), 0);
    const total = Math.max(CUSTOMER_DELETION_DELAY_DAYS, remaining);
    return { elapsed: total - remaining, total };
  });

  const deleteOnParams = () => ({
    deleteOn: customer.meta.deleteOn,
    formatParams: { deleteOn: { dateStyle: "long" } },
  });

  const openBilling = () =>
    window.location.assign(`${LEGACY_PLATFORM_BASE_URL}/customers/${customer.customerId}/billing/overview`);
  const openMeeting = () =>
    window.open(
      t(($) => $.SCHEDULED_FOR_DELETION_BANNER_PRIMARY_BUTTON_LINK),
      "_blank",
      "noopener",
    );

  return (
    <InlineBanner
      status="danger"
      title={
        canManageBilling()
          ? t(($) => $.SCHEDULED_FOR_DELETION_BANNER_TITLE, deleteOnParams())
          : t(($) => $.SCHEDULED_FOR_DELETION_BANNER_NO_PERMISSION_TITLE)
      }
      description={
        canManageBilling()
          ? undefined
          : t(($) => $.SCHEDULED_FOR_DELETION_BANNER_NO_PERMISSION_DESCRIPTION, deleteOnParams())
      }
      primaryAction={
        canManageBilling()
          ? { label: t(($) => $.SCHEDULED_FOR_DELETION_BANNER_SECONDARY_BUTTON), onClick: openBilling }
          : undefined
      }
      secondaryAction={
        canManageBilling()
          ? { label: t(($) => $.SCHEDULED_FOR_DELETION_BANNER_PRIMARY_BUTTON), onClick: openMeeting }
          : undefined
      }
      progressBars={[
        {
          label: t(($) => $.SCHEDULED_FOR_DELETION_BANNER_PROGRESS_DAYS),
          value: daysProgress().elapsed,
          max: daysProgress().total,
        },
      ]}
    />
  );
};

export default ScheduledForDeletionBanner;
